import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'equal', 'Equal', [["path",{"d":"M5 10h14"}],["path",{"d":"M5 14h14"}]]);